import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// helpers
import get from 'lodash.get';

function PdpSharedDetailDealerLocation({ item }) {
    const dealerLocation = get(item, 'seller.shippingAddress.displayCityStateCountry');

    if (!dealerLocation) {
        return null;
    }
    return <span data-tn="pdp-spec-dealer-location">{dealerLocation}</span>;
}

PdpSharedDetailDealerLocation.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailDealerLocation, {
    item: graphql`
        fragment PdpSharedDetailDealerLocation_item on Item {
            seller {
                shippingAddress {
                    displayCityStateCountry
                }
            }
        }
    `,
});
